var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSteamRollerChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Chips_Truck_4",
    width: 92,
    height: 28,
    viewBox: "0 0 92 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-3,.cls-7{fill:none}.cls-3{stroke:#212121;stroke-miterlimit:10}.cls-6{stroke:none}\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    width: 92,
    height: 28,
    fill: "#e0a32b",
    rx: 14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(-894 -926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Steamroller_Icon",
    transform: "translate(960 928)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1087",
    className: "cls-3",
    transform: "translate(9 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1V2H0z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    x: 0.5,
    y: 0.5,
    className: "cls-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1088",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H4V2H0z",
    className: "cls-6",
    transform: "translate(11 5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H3.5V1.5H0.5z",
    className: "cls-7",
    transform: "translate(11 5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    fill: "#212121",
    d: "M19 11.663V11h1V8a1 1 0 0 0-1-1h-2V4a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v3H5a1 1 0 0 0-1 1v3h1v.663a3.5 3.5 0 1 0 2 0V11h3v5h4v-5h3v.663a3.5 3.5 0 1 0 2 0zM8.5 15A2.5 2.5 0 1 1 5 12.712V15a1 1 0 0 0 2 0v-2.288A2.5 2.5 0 0 1 8.5 15zm5.5-5h-1v5h-2v-5H5V8h3V4h8v4h3v2h-5zm4 7.5a2.5 2.5 0 0 1-1-4.788V15a1 1 0 0 0 2 0v-2.288a2.5 2.5 0 0 1-1 4.788z"
  })), /*#__PURE__*/React.createElement("text", {
    id: "\\u05DE\\u05DB\\u05D1\\u05E9",
    fill: "#fff",
    fontFamily: "Heebo-Medium, Heebo",
    fontSize: "16px",
    fontWeight: 500,
    transform: "translate(951 945)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -41.047,
    y: 0
  }, "\u05DE\u05DB\u05D1\u05E9")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteamRollerChip);
export default __webpack_public_path__ + "static/media/steam_roller_chip.454f38065a6557937d2d67b0acc4a6ae.svg";
export { ForwardRef as ReactComponent };